/* ============================================================
   RPNT · comportamiento
   1. Telon: las luces se apagan al salir de una pagina y se encienden al llegar
   2. Inversion de tono bone <-> ink en la ficha de producto
   3. Variantes, bolsa, menu, revelado
   ============================================================ */
(function () {
  'use strict';

  var CLAVE_TELON = 'rpnt:telon';
  var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var html = document.documentElement;

  /* ---------- utilidades ---------- */
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function guardar(clave, valor) {
    try { valor === null ? sessionStorage.removeItem(clave) : sessionStorage.setItem(clave, valor); } catch (e) {}
  }

  function dinero(centavos) {
    var formato = (window.RPNT && window.RPNT.formatoDinero) || '${{amount}}';
    var valor = centavos / 100;
    function agrupar(txt, milesConPunto) {
      var partes = txt.split('.');
      var entera = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, milesConPunto ? '.' : ',');
      return partes[1] ? entera + (milesConPunto ? ',' : '.') + partes[1] : entera;
    }
    return formato.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, tipo) {
      switch (tipo) {
        case 'amount_no_decimals':
          return agrupar(String(Math.round(valor)), false);
        case 'amount_with_comma_separator':
          return agrupar(valor.toFixed(2), true);
        case 'amount_no_decimals_with_comma_separator':
          return agrupar(String(Math.round(valor)), true);
        default:
          return agrupar(valor.toFixed(2), false);
      }
    });
  }

  /* ============================================================
     1. TELON
     Al salir: la pagina se apaga a tinta (el telon baja) y recien
     entonces se navega. Al llegar: layout/theme.liquid ya trae el
     telon cerrado desde el primer pintado (clase telon-cerrado en
     <html>) y aqui se levanta con la pagina nueva entrando.
     ============================================================ */
  function hayTelon() { return !!$('.telon'); }

  function apagar(alTerminar) {
    if (quieto || !hayTelon()) { alTerminar(); return; }
    html.classList.add('telon-baja');
    var listo = false;
    function fin() { if (listo) return; listo = true; alTerminar(); }
    setTimeout(fin, 330);
  }

  function encender() {
    if (!html.classList.contains('telon-cerrado')) return;
    if (quieto || !hayTelon()) { html.classList.remove('telon-cerrado'); return; }
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        html.classList.add('telon-sube');
        html.classList.remove('telon-cerrado');
        setTimeout(function () { html.classList.remove('telon-sube'); }, 800);
      });
    });
  }

  function navegable(a, ev) {
    if (ev.defaultPrevented || ev.button !== 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return false;
    if (!a || !a.href || a.target === '_blank' || a.hasAttribute('download')) return false;
    if (a.hasAttribute('data-sin-hoja') || a.hasAttribute('data-sin-telon')) return false;
    var u;
    try { u = new URL(a.href); } catch (e) { return false; }
    if (u.origin !== location.origin) return false;
    if (u.pathname === location.pathname && u.search === location.search && u.hash) return false;
    if (/^(mailto|tel):/.test(a.getAttribute('href') || '')) return false;
    return u.href !== location.href;
  }

  document.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('a[href]');
    if (!navegable(a, ev)) return;
    ev.preventDefault();
    var destino = a.href;
    guardar(CLAVE_TELON, '1');
    apagar(function () { window.location.href = destino; });
  });

  // si vuelve por bfcache o el navegador restaura la pagina, no dejar el telon puesto
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      guardar(CLAVE_TELON, null);
      html.classList.remove('telon-baja', 'telon-cerrado', 'telon-sube');
    }
  });
  window.addEventListener('pagehide', function () { html.classList.remove('telon-baja'); });

  /* ============================================================
     2. FICHA DE PRODUCTO: tono, talla, variante
     ============================================================ */
  function ficha() {
    var raiz = $('[data-ficha]');
    if (!raiz) return;

    var datos = JSON.parse($('[data-variantes]', raiz).textContent);
    var campoId = $('[name="id"]', raiz);
    var boton = $('[data-agregar]', raiz);
    var precio = $('[data-precio]', raiz);
    var seleccion = { tono: null, talla: null };

    // arranca con la primera variante disponible
    var inicial = datos.find(function (v) { return v.disponible; }) || datos[0];
    if (inicial) { seleccion.tono = inicial.tono; seleccion.talla = inicial.talla; }

    function aplicarTono(t) {
      document.documentElement.setAttribute('data-tono', t === 'ink' ? 'ink' : 'bone');
    }

    function variante() {
      return datos.find(function (v) { return v.tono === seleccion.tono && v.talla === seleccion.talla; });
    }

    function pintar() {
      aplicarTono(seleccion.tono);

      $$('[data-tono-btn]', raiz).forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.dataset.tonoBtn === seleccion.tono));
      });

      $$('[data-talla-btn]', raiz).forEach(function (b) {
        var t = b.dataset.tallaBtn;
        var v = datos.find(function (x) { return x.tono === seleccion.tono && x.talla === t; });
        b.setAttribute('aria-pressed', String(t === seleccion.talla));
        b.disabled = !v || !v.disponible;
      });

      var v = variante();
      if (v) {
        campoId.value = v.id;
        if (precio) precio.textContent = dinero(v.precio);
        boton.disabled = !v.disponible;
        boton.textContent = v.disponible ? boton.dataset.textoDisponible : boton.dataset.textoAgotado;
        var u = new URL(location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u);
      } else {
        boton.disabled = true;
        boton.textContent = boton.dataset.textoAgotado;
      }
    }

    raiz.addEventListener('click', function (e) {
      var bt = e.target.closest('[data-tono-btn]');
      if (bt) { seleccion.tono = bt.dataset.tonoBtn; pintar(); return; }
      var bl = e.target.closest('[data-talla-btn]');
      if (bl && !bl.disabled) { seleccion.talla = bl.dataset.tallaBtn; pintar(); }
    });

    pintar();

    // favorito: solo local, sin cuenta
    var fav = $('[data-favorito]', raiz);
    if (fav) {
      var llave = 'rpnt:fav:' + fav.dataset.favorito;
      var guardado = false;
      try { guardado = localStorage.getItem(llave) === '1'; } catch (e) {}
      fav.setAttribute('aria-pressed', String(guardado));
      fav.addEventListener('click', function () {
        guardado = !guardado;
        fav.setAttribute('aria-pressed', String(guardado));
        try { guardado ? localStorage.setItem(llave, '1') : localStorage.removeItem(llave); } catch (e) {}
      });
    }

    // agregar a la bolsa sin recargar
    var form = raiz.closest('form') || $('form[action*="/cart/add"]', raiz);
    if (form) {
      form.addEventListener('submit', function (e) {
        if (window.RPNT && window.RPNT.vistaPrevia) {   // vista previa sin tienda
          e.preventDefault();
          var antes = boton.textContent;
          boton.textContent = boton.dataset.textoListo;
          setTimeout(function () { boton.textContent = antes; }, 1600);
          return;
        }
        if (!window.fetch) return;                 // sin fetch: envio normal
        e.preventDefault();
        boton.disabled = true;
        var previo = boton.textContent;
        boton.textContent = boton.dataset.textoEnviando;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(campoId.value), quantity: 1 }] })
        })
          .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
          .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
          .then(function (c) {
            contarBolsa(c.item_count);
            boton.textContent = boton.dataset.textoListo;
            setTimeout(function () { boton.textContent = previo; boton.disabled = false; }, 1600);
          })
          .catch(function () { form.submit(); });
      });
    }
  }

  function contarBolsa(n) {
    $$('[data-bolsa-cuenta]').forEach(function (el) {
      el.textContent = n > 0 ? '(' + n + ')' : '';
    });
  }

  /* ============================================================
     3. MENU, REVELADO
     ============================================================ */
  function menu() {
    var panel = $('[data-menu]');
    if (!panel || panel.dataset.atado === '1') return;
    panel.dataset.atado = '1';
    function estado(v) {
      panel.setAttribute('data-abierto', String(v));
      document.body.style.overflow = v ? 'hidden' : '';
    }
    $$('[data-menu-abrir]').forEach(function (b) { b.addEventListener('click', function () { estado(true); }); });
    $$('[data-menu-cerrar]').forEach(function (b) { b.addEventListener('click', function () { estado(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') estado(false); });
  }

  function revelar() {
    var items = $$('.revela');
    if (!items.length) return;
    if (quieto || !('IntersectionObserver' in window)) {
      items.forEach(function (i) { i.classList.add('visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('visible'); obs.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px' });
    items.forEach(function (i) { obs.observe(i); });
  }

  function arrancar() {
    encender();
    ficha();
    menu();
    revelar();
    // el tono vuelve a bone fuera de la ficha de producto
    if (!$('[data-ficha]')) document.documentElement.setAttribute('data-tono', 'bone');
  }

  window.RPNT = window.RPNT || {};
  window.RPNT.iniciar = arrancar;
  window.RPNT.apagar = apagar;
  window.RPNT.girar = function (fase, cb) { apagar(cb); };          // compatibilidad con el nombre viejo
  window.RPNT.marcarGiro = function () { guardar(CLAVE_TELON, '1'); };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();

  document.addEventListener('shopify:section:load', arrancar);
})();
